






































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant';
@Component({
    components: {},
}) 
export default class classList extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:[]
    })
    list:Array<any>;

    @Prop({
        default:false
    })
    isManage:Boolean;
    @Prop({
        default:""
    })
    activeId:String;

    Loop=null;



    async mounted() {
       
    }
    async created() {
    
    }

    getActiveStatus(v){
        if(this.isManage) return;
        let val = false;
        val = this.activeId.indexOf(v.id)>-1; 
        return val;
    }

    addChild(item){
        this.$emit('addChild',item);
    }
    deletFirst(item){
        this.$emit('deletFirst',item);
    }
    editClass(item,index){
        let form = Object.assign({},item,
           {
            sort:index+1,
           }
        )
        this.$emit('editClass',form);
    }
    deletChild(item){
        this.touchstart(item);
        setTimeout(() => {
            this.touchend()
        }, 200);
    }

  
    touchstart(item){
        if(!this.isManage)return;
        console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
           this.$emit("deleteSecondClass",item)
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    touchend(){
        if(!this.isManage)return;
        console.log('touchend');
        clearInterval(this.Loop);
    }
    chooseFun(item,v){
        if(this.isManage) return;
        let id= item.id+','+v.id;
        this.$emit("chooseFun",{
            id:id,
            name:item.name+'-'+v.name
        })
    }
    chooseFirst(item){
        if(this.isManage) return;
        if(item.items.length>0) return;
        let id= item.id;
        this.$emit("chooseFun",{
            id:id,
            name:item.name
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/classList.vue